module.exports = __webpack_public_path__ + "static/media/spectrophotometer-info-6.b81904a9.svg";